/**
 * PremiumSubscriptionsPolicyPage
 *
 * Static public page displaying the Premium Subscriptions Policy.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import premiumSubscriptionsPolicyHtml from './content/premiumSubscriptionsPolicy.html?raw';

export const PremiumSubscriptionsPolicyPage = () => {
  const { l10n } = useLocale();
  return (
    <LegalDocumentPage
      qaId="legal-premium-subscriptions-policy"
      title={l10n.legal.premiumSubscriptionsPolicy}
      htmlContent={premiumSubscriptionsPolicyHtml}
    />
  );
};
